export const sortOptions = [
    { label: 'Price - High to Low', value: 'DESC:min_discounted_price' },
    { label: 'Price - Low to High', value: 'ASC:min_discounted_price' },
];

export const getDefaultSortLabel = () => 'Relevance';

export const getSortLabel = (sortValue) => {
    const option = sortOptions.find(opt => opt.value === sortValue);
    return option ? option.label : getDefaultSortLabel();
}; 